import React from "react";
import {
    FormControl,
    FormLabel,
    FormGroup,
    FormControlLabel,
    FormHelperText,
    Switch,
    makeStyles,
    Theme,
    createStyles,
    Button,
    CircularProgress,
    Typography,
    TextField
} from "@material-ui/core";
import { apiDelete, apiPost, useDataUnlessForbidden } from "../../services/api";
import { useSnackbar } from "notistack";
import Loading from "../shared/Loading";
import { useAuth } from "../../services/authentication";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        viewProjectButton: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,

            padding: theme.spacing(1, 10, 1, 10),
            fontSize: "1rem",
            "&:hover": {
                backgroundColor: theme.palette.primary.dark
            },
            "&:disabled": {
                backgroundColor: "#bdbdbd",
                color: "#f5f5f5"
            }
        }
    })
);

export interface IApiAccessProperties {
    apiAccessEnabled: boolean;
    apiAccessKey?: string;
}

export interface IPreferencesFormProps {
    userId?: string;
    onPreferencesUpdated?(): void;
}
export const UserApiAccessForm: React.FC<IPreferencesFormProps> = props => {
    const { authState } = useAuth();
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const [user, loadUser] = useDataUnlessForbidden<IApiAccessProperties>(
        `users/me/get-api-access-key`,
        () =>
            enqueueSnackbar(
                "We couldn't retrieve user preferences. Please refresh and try again.",
                { variant: "error" }
            )
    );

    const [apiAccessEnabled, setApiAccessEnabled] = React.useState(false);

    const updateApiAccessProperties = (properties?: IApiAccessProperties | null) => {
        if (properties) {
            setApiAccessEnabled(properties.apiAccessEnabled);

            if (properties.apiAccessEnabled) {
                setPassword(properties.apiAccessKey || "");
                setUsername(authState?.user?.email || "");
            } else {
                setPassword("***********");
                setUsername("***********");
            }
        } else {
            setApiAccessEnabled(false);
            setPassword("***********");
            setUsername("***********");
        }
    };

    const onReceiveInAppNotificationsChange = async (event: {
        target: { checked: React.SetStateAction<boolean> };
    }) => {
        setApiAccessEnabled(event.target.checked);

        if (event.target.checked) {
            const response = await apiPost("users/me/enable-api-access");

            updateApiAccessProperties(response);
        } else {
            const response = await apiDelete("users/me/disable-api-access");

            updateApiAccessProperties(response);
        }
    };

    const [password, setPassword] = React.useState("");

    const onEmailChanged = (event: {
        target: { value: React.SetStateAction<string> };
    }) => {
        setPassword(event.target.value);
    };

    const [username, setUsername] = React.useState("");

    const onEmailChanged2 = (event: {
        target: { value: React.SetStateAction<string> };
    }) => {
        setUsername(event.target.value);
    };

    React.useEffect(() => {
        updateApiAccessProperties(user);
    }, [user, loadUser]);

    const generateApiKey = async () => {
        const response = await apiPost("users/me/rotate-api-access-key");

        updateApiAccessProperties(response);
    };

    const updatePreferences = async () => {

        if (props.onPreferencesUpdated) {
            props.onPreferencesUpdated();
        }
    };

    return (
        <>
            {loadUser && (
                <>
                    <FormControl component="fieldset">
                        <Loading>
                            <CircularProgress />
                        </Loading>
                        <Typography
                            variant="subtitle1"
                            style={{
                                position: "absolute",
                                left: "-15px",
                                top: "60px"
                            }}
                        >
                            Loading Preferences...
                        </Typography>
                    </FormControl>
                </>
            )}

            {user && (
                <>
                    <FormControl component="fieldset" style={{ width: "100%" }}>
                        <FormLabel component="legend">API Access</FormLabel>
                        <FormHelperText>
                            Controls api access to your project(s)
                        </FormHelperText>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Switch
                                        color="primary"
                                        name="receiveInAppNotifications"
                                        checked={apiAccessEnabled}
                                        onChange={
                                            onReceiveInAppNotificationsChange
                                        }
                                    />
                                }
                                label="Enable API Access"
                            />
                            <TextField
                                label="Username (E-Mail Address)"
                                onChange={onEmailChanged2}
                                type="email"
                                variant="filled"
                                value={username}
                                required
                                fullWidth
                                inputProps={{ maxLength: 450, readOnly: true }}
                            />
                            <TextField
                                label="Password (API Key)"
                                onChange={onEmailChanged}
                                type="email"
                                variant="filled"
                                value={password}
                                required
                                fullWidth
                                inputProps={{ maxLength: 450, readOnly: true }}
                            />
                            <Button
                                style={{ alignSelf: "end", width: "125px" }}
                                onClick={generateApiKey}
                                className={classes.viewProjectButton}
                            >
                                Regenerate
                            </Button>
                        </FormGroup>

                        <br />
                        <br />
                        <Button
                            onClick={updatePreferences}
                            className={classes.viewProjectButton}
                        >
                            Close
                        </Button>
                    </FormControl>
                </>
            )}
        </>
    );
};

export default UserApiAccessForm;
